import { lazy, Suspense } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import { Footer } from "../components/footer";
import { Navbar } from "../components/navbar";
import { ProtectedRoute } from "../components/protected-route";
import { ScrollRestoration } from "../components/scroll-restoration";
import { Skeleton } from "../components/ui/skeleton";
import { HomePage } from "../pages/HomePage";
import { NotFoundPage } from "../pages/NotFoundPage";

const SearchPage = lazy(() => import("../pages/SearchPage").then((module) => ({ default: module.SearchPage })));
const ProductPage = lazy(() => import("../pages/ProductPage").then((module) => ({ default: module.ProductPage })));
const CartPage = lazy(() => import("../pages/CartPage").then((module) => ({ default: module.CartPage })));
const SellerPortal = lazy(() => import("../pages/SellerPortal").then((module) => ({ default: module.SellerPortal })));
const AdminPortal = lazy(() => import("../pages/AdminPortal").then((module) => ({ default: module.AdminPortal })));
const LoginPage = lazy(() => import("../pages/LoginPage").then((module) => ({ default: module.LoginPage })));

export function App() {
  const location = useLocation();
  const isPortalRoute = ["/login", "/seller", "/admin"].some((path) => location.pathname.startsWith(path));

  return (
    <div className="min-h-screen bg-background text-foreground">
      <ScrollRestoration />
      {isPortalRoute ? null : <Navbar />}
      <Suspense fallback={<main className="container-pad py-8"><Skeleton className="h-96" /></main>}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/products/:slug" element={<ProductPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/seller"
            element={
              <ProtectedRoute role="seller">
                <SellerPortal />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute role="admin">
                <AdminPortal />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
      {isPortalRoute ? null : <Footer />}
    </div>
  );
}
